import Vue from "vue";
Vue.locale = () => {};

export const defaultLocale = "en";
export const languages = {
    en: require("./data/en.json"),
    ru: require("./data/ru.json")
};
export const supportedLangs = Object.keys(languages);